import React, { useState } from 'react';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import IconItem from 'components/common/icon/IconItem';
import axios from "axios";
import { useEffect } from 'react'
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Col } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const MedFrequencyTable = (props) => {

    function handleEditInput(dataObj) {
        props.onCallEditParent(dataObj);
    }

    const columns = [
        {
            accessorKey: 'frequency',
            header: 'Frequency Name',
            meta: {
                headerProps: { className: 'pe-1 col-lg-8 text-start text-900' }
            }
        },
        // {
        //     accessorKey: 'updated_by',
        //     header: 'Updated By',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'updatedate',
        //     header: 'Updated Date',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        {
            accessorKey: 'Action',
            header: '',
            meta: {
                headerProps: {
                    className: 'text-900'
                },
                cellProps: {
                    className: 'align-items-center'
                }
            },
            enableSorting: false,
            cell: ({ row: { original } }) => {
                return <IconItem
                    tag="button"
                    icon={['far', 'edit']}
                    size="sm"
                    onClick={() => handleEditInput({
                        frequency: original.frequency,
                        is_active: original.is_active,
                        frequency_id: original.frequency_id
                    })}
                    className="btn rounded-3 me-2 fs-11 align-items-center"
                />
            }
        }
    ];

    const [presFrequency, setPresFrequency] = useState([]);
    const [error, setError] = useState(true);
    // const [showModal, setShowModal] = useState(false);

    // const handleMedFreqModal = (frequencyValue, isActive, frequencyId) => {
    //     localStorage.setItem("frequencyValue", frequencyValue);
    //     localStorage.setItem("frequencyId", frequencyId);
    //     localStorage.setItem("isActive", isActive);
    //     setShowModal(true);
    // };

    useEffect(() => {

        async function fetchPresFrequency() {

            let tokenStr = localStorage.getItem("accessToken");

            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/list-prescription-frequencies", { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            const results = []
            const drugFreqData = data.data

            if (data.status) {
                drugFreqData.forEach((value) => {
                    let active_sts = value.is_active ? "active" : "inactive";
                    if (props.active_status == active_sts) {
                        results.push({
                            frequency_id: value.id,
                            frequency: value.name,
                            // updated_by: value.updated_by,
                            is_active: value.is_active// == 1 ? 0 : 1
                            // updatedate: value.updated != null ? moment(value.updated, 'YYYY-MM-DD').format('MM/DD/YY') : ""
                        });
                    }
                });
                if (results.length > 0) {
                    setPresFrequency(results);
                    setError(true)
                } else {
                    setError(false)
                }
            }
            else {
                toast.info("No Prescription Frequency found in this list");
            }
        }

        fetchPresFrequency();

        async function refreshMedFreqDetails() {
            fetchPresFrequency();
        }

        if (props.trigger > 0) {
            //console.log(props.trigger);
            refreshMedFreqDetails();
        }

    }, [props.trigger]);

    const table = useAdvanceTable({
        data: presFrequency,
        columns,
        selection: false,
        sortable: true,
        pagination: true,
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Col xs="4" className="mb-3 ms-auto">
                    <AdvanceTableSearchBox placeholder="Search..." />
                </Col>
                {error ? <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle text-center"
                    rowClassName="text-nowrap align-middle "//text-center
                    tableProps={{
                        size: 'lg',
                        striped: true,
                        className: 'fs-10 mb-0'
                    }}
                /> : <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '50px' }}>
                    <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                </div>}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
            {/* <EditMedFreqModal show={showModal} setShow={setShowModal} /> */}
        </div>
    );
};

export default MedFrequencyTable;
